import { render, staticRenderFns } from "./Alert2-RAG.vue?vue&type=template&id=dd284b08&scoped=true"
import script from "./Alert2-RAG.vue?vue&type=script&lang=js"
export * from "./Alert2-RAG.vue?vue&type=script&lang=js"
import style0 from "./Alert2-RAG.vue?vue&type=style&index=0&id=dd284b08&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd284b08",
  null
  
)

export default component.exports